import React from 'react'

const index = () => {
  return (
    <div> here create new projects</div>
  )
}

export default index